import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLocale } from '../../contexts/LocaleContext';
import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { AdminSidebar } from './AdminSidebar';
import { DeskHeader } from '../DeskHeader';
import { AdminAccessDenied } from './AdminAccessDenied';
import { useIsMobile } from '../../hooks/use-mobile';
import { PANEL_BODY_FILL_CLASSNAME, APP_PANEL_SCROLL_CLASSNAME } from '../../constants/layout';

export const AdminLayout: React.FC = () => {
  const { user, loading } = useAuth();
  const { t } = useLocale();
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div>{t('loading')}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.admin) {
    return (
      <div className="p-8">
        <AdminAccessDenied />
      </div>
    );
  }

  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset className="min-h-0 max-w-full" style={{ overflowX: 'hidden', maxWidth: '100%' }}>
        <DeskHeader showSearch={false} />
        <div
          data-app-scroll-region
          className={`${PANEL_BODY_FILL_CLASSNAME} ${APP_PANEL_SCROLL_CLASSNAME}`}
          style={{
            padding: isMobile ? '1rem' : '2rem',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflowX: 'hidden',
          }}
        >
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};
